const l = {
  id: "TexasAllOrNothing",
  name: "All Or Nothing",
  style: {
    colorPrimary: "#f39800"
  }
};
export {
  l as default
};
